var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SectionTemplate',{staticClass:"workplace-safety",attrs:{"title":"Segurança do Trabalho"}},[_c('ServicesSliderWidget',{attrs:{"list":_vm.list,"items-to-show":_vm.itemsToShow}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }